import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";
import { HolidayCreatePayload, HolidayDTO, HolidayScheduleOptionDTO } from "../../models/HolidayDTO";

const RESOURCE_URL_V2 = "/admin/campus/";

/*
	Same convention as AttendanceService: methods return the raw AxiosResponse and
	the controller reads `response.data`. The v2 backend answers these endpoints
	with the bare payload (no {data:...} envelope) for non-paginated resources.
*/
export class AcademicCalendarService {

	getHolidays = async (campusId: number, from: string, to: string): Promise<AxiosResponse<HolidayDTO[]>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/academicCalendar`;
		const response = await axiosInstance.get<HolidayDTO[]>(uri, { params: { from, to } });
		return response;
	}

	createHoliday = async (campusId: number, payload: HolidayCreatePayload): Promise<AxiosResponse<HolidayDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/academicCalendar`;
		const response = await axiosInstance.post<HolidayDTO>(uri, payload);
		return response;
	}

	deleteHoliday = async (campusId: number, holidayId: number): Promise<AxiosResponse> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/academicCalendar/${holidayId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	getSchedulesOnDate = async (campusId: number, date: string): Promise<AxiosResponse<HolidayScheduleOptionDTO[]>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/academicCalendar/_schedules`;
		const response = await axiosInstance.get<HolidayScheduleOptionDTO[]>(uri, { params: { date } });
		return response;
	}
}
